import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { UserImport } from '../../interfaces/user-import/user-import';

@Injectable({
  providedIn: 'root'
})
export class UserImportService {

  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
  }

  public userImport = (corporationId: string, userGroupId: string, userImport: UserImport) => {
    return this.http.post<UserImport>(
      this.populateBaseLink([corporationId, userGroupId]),
      userImport,
      this.generateHeaders());
  };

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  };


  private populateBaseLink(routeParams: string[]): string {
    var tempURL = `${this.config.rootUrl}/corporations/[0]/usergroups/[1]/UserImport`;
    for (let i = 0; i < routeParams.length; i++) {
      tempURL = tempURL.replace(`[${i}]`, routeParams[i]);
    }
    return tempURL;
  }
}
